/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';

var LOG = require('logger').getLogger('provider.apply');

var $ = window.jQuery = require('base'),_api= module.exports;

var common_header = require('../common/com.jufeng.common.header');

var layer = $.Deferred();
require.ensure(['layer'], function () {
	var deferred = layer;
	$.extend(deferred, require('layer'));
	var ori_done = deferred.done;
	deferred.done = function (fn) {
		ori_done($.proxy(fn, null, deferred));
	}
	deferred.resolve(deferred);
})

var model_deferred = $.Deferred();
require.ensure('model', function(){
	var deferred = model_deferred, model_factory = require('model');
    var ori_done = deferred.done;
    deferred.done = function(fn, ctx) {
		ori_done($.proxy(fn, ctx, model_factory));
    }
    deferred.resolve(model_factory);
})

// JQuery中没有reset方法
// 通过调用 DOM 中的reset方法来重置表单
$('#btn_reset_apply').click(function(){
	$("#form_body")[0].reset();
})

$('#btn_submit_apply').click(function(){
	model_deferred.done(function(model_factory){
		var apply = model_factory.build_model('#provider_apply_container'), all_ok = true;
		$('#provider_apply_container').find('[data-prop-path]').each(function(){
			var em = $(this), path = em.data('prop-path'), val = model_factory.valOf(apply, path);
			
			// 排除传真和qq
			if ( path != 'fax' && path != 'qq' && !val || val == '请选择' || val == '省、直辖市、自治区' || val == '城市') {
				em.trigger('require');
				all_ok = false;
				return false;
			}
			// 注册资金只能为整数！
			if (path == 'registered_capital'){
				var pattern = /^\+?[1-9][0-9]*$/;
				if (!pattern.test(val)) {
					em.trigger('regex');
					all_ok = false;
					return false;
				}
			}
			// 验证国内电话号码
			if (path == 'tel'){
				var pattern = /^(\(\d{3,4}\)|\d{3,4}-)?\d{7,8}$/;
				if(!pattern.test(val)){
					em.trigger('regex');
					all_ok = false;
					return false;
				}
			}
			
			// 验证电子邮箱
			if(path == 'email'){
				var pattern = /^\w+(@\w+)(\.(com|cn))$/g;
				if(!pattern.test(val)){
					em.trigger('regex');
					all_ok = false;
					return false;
				}
			}
		});
		if (all_ok === true) {
			// 拼接地址
			var address = apply.province + apply.city + apply.town + apply.address;
			apply.address = address.replace("县、区、镇", "");
			delete apply.province;
			delete apply.city;
			delete apply.town;
			LOG.info(JSON.stringify(apply));
			//LOG.info(apply.securityCode);
			
			
			
			$.ajax({
				url : '/provider_apply_save.htm?securityCode=' + apply.securityCode,
				type : 'post',
				contentType : 'application/json',
				data : JSON.stringify(apply),
				dataType  : 'json',
				success : function(tip){
					// 验证码验证
					if(tip.error_code === '101'){
						$('#provider_apply_container').find('[data-prop-path="securityCode"]').trigger('regex');
					} else if(tip.result === 'success'){
						layer.alert("提交申请成功", {
							title : '温馨提示',
							icon : 1,
							closeBtn : 0,
							shade : [0.8, '#393D49'],
							btn : ['确定']
						}, function(){
							window.location.href = '/index.htm';
						})
					} else {
						layer.alert("系统正忙，请稍后再试...", {
							title : '温馨提示',
							icon : 5,
							closeBtn : 1,
							shade : [0.8, '#393D49'],
							shadeClose : true,
						})
					}
					
					
					LOG.info(JSON.stringify(tip));
				}
			})
		}
	})
})

var qtip2_deferred = $.Deferred();
require.ensure('qtip2', function () {
	var deferred = qtip2_deferred, qtip2 = require('qtip2');
	var ori_done = deferred.done;
	deferred.done = function (fn, ctx) {
		ori_done($.proxy(fn, ctx, qtip2));
	}
	deferred.resolve(qtip2);
})
// 初始化qtip2
qtip2_deferred.done(function(){
	select_deferred.done(function(){
		init_qtip($('#provider_apply_container'))
	})
})


function init_qtip(context){
	$('[data-tip]', context).each(function () {
		var that = $(this);
		var tip_options = new Function("return " + that.data('tip')).call(this);
		var events = $.map(tip_options, function (t, e) {
				return e;
			})
			that.qtip({
				content : function (e, api) {
					var visible_qtips = $('div[id^="qtip-"].qtip:visible').not('#' + api._id);
					if (visible_qtips.length) {
						setTimeout(function () {
							api.toggle(false, e)
						}, 0)
					} else {
						e.focus !== false && $(this).filter('input[type="text"]').focus().select();
					}
					return tip_options[e.type] || e.content;
				},
				show : events.join(' ') + ' error',
				hide : 'keydown blur change',
				position : $.extend({
					viewport : $(window),
					target : (tip_options['target'] && $(that.data('select2').$container)) || true,
					my : 'left center',
					at : 'right center',
				}, tip_options['position']),
				style : 'input_tip1'
			})
	})

}


var select_deferred = $.Deferred();


// 加载省份、城市、县区信息
$.ajax({
	url : '/location_4_select.htm',
	dataType : 'json',
	success : function (locations) {
		require.ensure(['select2'], function () {
			require('select2');
			var el_province = $('select[data-prop-path="province"]'),
			el_city = $('select[data-prop-path="city"]'),
			el_town = $('select[data-prop-path="town"]');
			
			el_province.select2({width:160});
			el_city.select2({width:130});
			el_town.select2({width:120});
			
			select_deferred.resolve();
			
			$.each(locations, function () {
				var option = $('<option>' + this.name + '</option>');
				option.data('cities', this.children)
				el_province.append(option);
			});
			
			el_province.on('change', function () {
				var cities = $(this).find('option:selected').data('cities');
				el_city.empty();
				el_town.empty();
				el_city.append($('<option>'+ "城市" + '</option>'));
				el_town.append($('<option>'+ "县、区、镇" + '</option>'));
				if (cities === undefined ) return;
				$.each(cities, function () {
					var option = $('<option>' + this.name + '</option>');
					option.data('towns', this);
					el_city.append(option);
					
				})
				el_city.select2({width:130});
				var qtip_obj = el_city.data('qtip');
				qtip_obj.options.position.target = el_city.data('select2').$container;
				el_town.select2({width:120});
			});
			
			$(document).on("change",".loc_city",function(){
				el_town.empty();
				el_town.append($('<option>'+ "县、区、镇" + '</option>'));
				var name = $(this).find('option:selected').val();
				if (name == "城市") return;
				$.ajax({
				url : '/city_4_select.htm',
				data:{name:name},
				dataType : 'json',
				success : function (city) {
					var towns = city[0].children;
					$.each(towns, function(){
						el_town.append('<option>' + this.name + '</option>');
					})
					el_town.select2({width:120});
					
				}
			});
				
				
			});
		
		})
	}
});

$('.txt_btn').off('click').on('click', refreshCode);
$('#imgValidCode').off('click').on('click', refreshCode);

// 换一张验证码
function refreshCode() {
	var objImg = document.getElementById('imgValidCode');
	objImg.src = '/getSecurityCode.htm?c=4&s=18&l=3&t=' + new Date().getTime();
}

// ==============================================

require('../css/bootstrap.css');
require('../css/font/fonts.css');
require('../css/cat_nav.less');
require('../css/style2.css');
require('../css/select2.css');
require('../css/common.css');
require('../css/header.less');
require('../css/footer.css');
require('../css/floor_right.less');
require('../css/banner.css');
require('../css/productList.less');
require('../css/hotBox.css');
require('../css/activity.less');
require('../css/layer.css');
require('../css/credit_apply.css');
require('../css/jquery.qtip.min.css');


// WEBPACK FOOTER //
// ./src/main/javascript/provider/com.jufeng.provider.apply.js